import React from 'react'
import PropTypes from 'prop-types'
import options from '@spa/utils/options'
import { _ } from '../../gettext'

export const ServiceAppointmentPreview = ({ reservation, modal }) => {
  const data = reservation.formData
  const model = reservation.model

  return (
    <div className="card">
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-4">
            <label>{_('Začátek:')}</label><br />
            {data.from}
          </div>
          <div className="col-md-4">
            <label>{_('Konec:')}</label><br />
            {data.to}
          </div>
          <div className="col-md-4">
            <label>{_('Přístroje:')}</label><br />
            {model.new_nazev_pristroje_text}
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-4">
            <label>{_('Výzkumná skupina:')}</label><br />
            {model.ge_res_groupid ? model.ge_res_groupid.Name : '---'}
          </div>
          <div className="col-md-4">
            <label>{_('Projekt:')}</label><br />
            {model.psa_projectid ? model.psa_projectid.Name : '---'}
          </div>
          <div className="col-md-4">
            <label>{_('Status:')}</label><br />
            {options.reservationStatuses[data.statusCode]}
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-4">
            <label>{_('Typ rezervace:')}</label><br />
            {options.timeRequirements[data.timeRequirement]}
          </div>
          <div className="col-md-4">
            <label>{_('Realizováno pro:')}</label><br />
            {model.ge_realised_for_contactid.Name}
          </div>
        </div>
        {data.description ? (
          <div>
            <label>{_('Popis:')}</label><br />
            {data.description}
          </div>
        ) : null}
      </div>
    </div>
  )
}

ServiceAppointmentPreview.propTypes = {
  reservation: PropTypes.object,
  modal: PropTypes.object
}
